module.exports = __webpack_public_path__ + "static/media/5d.4991ce11.svg";